import React from 'react';
import { Button, Typography } from '@mui/material';

/*
  ToolbarButton: the standard toolbar button (Add, Delete, …) at the top of
  every list page — Transactions, Actions, Categories, Accounts, Budgets,
  Goals. One definition so the size, radius, and label weight stay aligned
  across pages instead of each page hand-rolling its own ActionButton.
*/
const ToolbarButton = ({ children, sx, ...props }) => (
  <Button
    variant="contained"
    size="small"
    sx={{
      borderRadius: 3,
      textTransform: 'none',
      fontWeight: 500,
      boxShadow: 'none',
      py: 1,
      px: { xs: 1.5, sm: 2.5 },
      minWidth: { xs: 90, sm: 110, md: 120 },
      whiteSpace: 'nowrap',
      ...sx,
    }}
    {...props}
  >
    <Typography variant="body2" fontWeight={500} noWrap sx={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
      {children}
    </Typography>
  </Button>
);

export default ToolbarButton;
